import React from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon';

interface IVehicleSpecificationIcon {
  icon: SeturIcon;
}

const VehicleSpecificationIcon = ({ icon }: IVehicleSpecificationIcon) => {
  const { xl } = useBreakpoint();

  return (
    <CustomIcon
      icon={icon}
      fontSize={xl === undefined || xl ? 20 : 16}
      paletteColor='grey'
    />
  );
};

export default VehicleSpecificationIcon;
